
















export enum Role {
    Guest = "guest",
    Agent = "agent",
    Admin = "admin",
    Supervisor = "supervisor"
}
